<template>
  <div :data-intro="dataIntro">
    <Button variant="outline" size="lg" @click="handleImportClick">
      Import
      <vue-feather type="plus" size="20" />
    </Button>
  </div>

  <TeamImport v-model:open="showImportTeam" />
  <ContactImportModal v-if="showImportCandidate" @handle-close="showImportCandidate = false" />
</template>

<script setup lang="ts">
import { computed, defineProps, ref } from 'vue';
import { Button } from '@/components/ui/button';
import ContactImportModal from '@/components/contact/ContactImportModal.vue';
import TeamImport from '@/components/team/TeamImport.vue';
import type { ContactRecordType } from '@/api/entity_types/Contact';

const { contactType } = defineProps<{
  contactType: ContactRecordType;
}>();

const showImportTeam = ref(false);
const showImportCandidate = ref(false);

const dataIntro = computed(() => {
  return contactType === 'Teammate'
    ? 'Use this button to import your agents using a CSV file.'
    : 'Use this button to import your candidates using a CSV file.';
});

const handleImportClick = () => {
  if (contactType === 'Teammate') {
    showImportTeam.value = true;
  } else {
    showImportCandidate.value = true;
  }
};
</script>
